import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import Configuration from '@/utils/configuration'

var protocol = Configuration.value('backendProtocol') || 'http';
var host = Configuration.value('backendHost') || 'api.local.industry.cloudprinter.com';
var port = Configuration.value('backendPort') || false;

if (port) {
  axios.defaults.baseURL = protocol + '://' + host + ':' + port;
} else {
  axios.defaults.baseURL = protocol + '://' + host;
}


Vue.use(VueAxios, axios);
